import {DefaultSchema} from '@/schema/DefaultSchema'
import {FieldSet, FieldComponent} from '@simpli/meta-schema'
import * as Component from '@simpli/vue-input'
import {NntTag} from '@/model/resource/NntTag'

export class InputNntTagSchema extends DefaultSchema {
  readonly name = 'InputNntTag'

  readonly fieldSet: FieldSet<NntTag> = {
    title: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 70,
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
  }
}
